export default __webpack_public_path__ + "static/media/user_logo.31beece0.png";